<template>
  <div>
    <monthly-report-download
      mode="teacher"
      :school="school" />
    <analytics-select
      mode="teacher"
      :school="school" />
  </div>
</template>

<script>
import AnalyticsSelect from '@/views/pages/Common/Analytics/AnalyticsSelect.vue';
import MonthlyReportDownload from '@/views/pages/Common/Analytics/MonthlyReportDownload.vue';

export default {
  name: 'analytics',
  components: {
    AnalyticsSelect,
    MonthlyReportDownload,
  },
  props: {
    school: {
      type: Object,
      default: null,
    },
  },
};
</script>
